import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function GrowthPortfolio() {
  const [children, setChildren] = useState([])
  const [selectedChild, setSelectedChild] = useState(null)
  const [portfolioData, setPortfolioData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [tab, setTab] = useState('overview')
  const [apiError, setApiError] = useState(null)

  useEffect(() => {
    fetch(`${API}/children`)
      .then(r => r.json())
      .then(d => { if (d.success) setChildren(d.data || []) })
      .catch(console.error)
  }, [])

  const loadPortfolio = (childId) => {
    setLoading(true)
    setApiError(null)
    fetch(`${API}/portfolio/${childId}`).then(r => r.json())
      .then(d => {
        if (d.success) {
          setPortfolioData(d.data)
        } else {
          setApiError(d.error || '加载失败')
          setPortfolioData(null)
        }
      })
      .catch(e => {
        console.error('[GrowthPortfolio]', e)
        setApiError('网络错误，请检查API服务')
        setPortfolioData(null)
      })
      .finally(() => setLoading(false))
  }

  const handleChildSelect = (e) => {
    const childId = e.target.value
    const child = children.find(c => c.id === childId)
    setSelectedChild(child || null)
    setTab('overview')
    setApiError(null)
    if (childId) loadPortfolio(childId)
    else setPortfolioData(null)
  }

  const openInNewTab = () => { if (selectedChild) window.open(`https://api.boxiaotu.cn/admin-5182/?child_id=${selectedChild.id}&institution_id=${selectedChild.institution_id}`, '_blank') }
  const getTypeName = (type) => ({ career: '🎯 职业探索', course: '📚 课程学习', activity: '🎉 活动' }[type] || '📋 活动')

  // 6维评估中文名映射
  const dimNames = {
    language: '语言力', art: '艺术力', performance: '表现力',
    social: '社交力', cognitive: '认知力', emotional: '情感力'
  }

  const cardStyle = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }

  const renderAssessments = (assessments) => {
    if (!assessments || assessments.length === 0) {
      return <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无能力评估记录</div>
    }
    return assessments.map(a => {
      let dims = a.dimensions || {}
      if (typeof dims === 'string') {
        try { dims = JSON.parse(dims) } catch { dims = {} }
      }
      return (
        <div key={a.id} style={{ padding: 20, background: '#fafafa', borderRadius: 8, marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
            <span style={{ fontWeight: 500 }}>评估日期：{a.assessment_date || a.date || '-'}</span>
            {a.teacher_comment && <span style={{ fontSize: 12, color: '#666' }}>评语：{a.teacher_comment}</span>}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
            {Object.entries(dims).map(([key, value]) => (
              <div key={key} style={{ textAlign: 'center', padding: 12, background: '#fff', borderRadius: 6, border: '1px solid #f0f0f0' }}>
                <div style={{ fontSize: 12, color: '#666' }}>{dimNames[key] || key}</div>
                <div style={{ fontSize: 22, fontWeight: 600, color: Number(value) >= 80 ? '#52c41a' : Number(value) >= 60 ? '#1890ff' : '#fa8c16' }}>{value}</div>
              </div>
            ))}
          </div>
          {a.growth_suggestion && (
            <div style={{ marginTop: 12, padding: 10, background: '#fff', borderRadius: 6, fontSize: 13, color: '#666' }}>
              <strong>成长建议：</strong>{a.growth_suggestion}
            </div>
          )}
        </div>
      )
    })
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📋 成长档案</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>查看孩子的成长档案数据，与成长档案系统数据同步</p>

      {/* 孩子选择器 */}
      <div style={{ background: '#fff', borderRadius: 8, padding: 20, marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <label style={{ fontSize: 14, color: '#666' }}>选择孩子：</label>
          <select
            value={selectedChild?.id || ''}
            onChange={handleChildSelect}
            style={{ padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, width: 300, fontSize: 14 }}
          >
            <option value="">请选择孩子</option>
            {children.map(c => (
              <option key={c.id} value={c.id}>
                {c.name} - {c.institution_name || c.school || '未分配机构'}
              </option>
            ))}
          </select>
          {selectedChild && (
            <button
              onClick={openInNewTab}
              style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}
            >在成长档案中打开 →</button>
          )}
        </div>
      </div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>加载中...</div>}

      {apiError && (
        <div style={{ padding: 20, background: '#fff1f0', borderRadius: 8, color: '#ff4d4f', marginBottom: 20 }}>
          ⚠ {apiError}
        </div>
      )}

      {selectedChild && !loading && !apiError && portfolioData && (
        <>
          {/* 统计卡片 */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 20 }}>
            {[
              { label: '参与活动', value: portfolioData.stats?.total_activities || 0, color: '#1890ff' },
              { label: '成长视频', value: portfolioData.stats?.total_videos || 0, color: '#52c41a' },
              { label: '作品数量', value: portfolioData.stats?.total_works || 0, color: '#722ed1' },
              { label: '积分余额', value: portfolioData.stats?.total_points || 0, color: '#fa8c16' },
            ].map(s => (
              <div key={s.label} style={{ ...cardStyle, borderLeft: `4px solid ${s.color}` }}>
                <div style={{ fontSize: 12, color: '#666' }}>{s.label}</div>
                <div style={{ fontSize: 28, fontWeight: 600, color: s.color }}>{s.value}</div>
              </div>
            ))}
          </div>

          {/* 标签页 */}
          <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
            {[
              { k: 'overview', l: '概览' },
              { k: 'activities', l: '活动记录' },
              { k: 'assessments', l: '能力评估' },
            ].map(t => (
              <button
                key={t.k}
                onClick={() => setTab(t.k)}
                style={{
                  padding: '8px 16px', border: 'none', borderRadius: 6,
                  background: tab === t.k ? '#1890ff' : '#f5f5f5',
                  color: tab === t.k ? '#fff' : '#666', cursor: 'pointer', fontSize: 14
                }}
              >{t.l}</button>
            ))}
          </div>

          {/* 概览 */}
          {tab === 'overview' && (
            <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
              <h4 style={{ fontSize: 14, marginBottom: 16 }}>👤 {portfolioData.child_name} - 成长概览</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div>
                  <div style={{ marginBottom: 12 }}>
                    <span style={{ color: '#666', fontSize: 13 }}>所属机构：</span>
                    <span style={{ fontWeight: 500 }}>{portfolioData.institution_id || '未分配'}</span>
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    <span style={{ color: '#666', fontSize: 13 }}>最近评估：</span>
                    <span style={{ fontWeight: 500 }}>{portfolioData.assessments?.[0]?.assessment_date || '暂无'}</span>
                  </div>
                  {portfolioData.child_info && (
                    <>
                      <div style={{ marginBottom: 12 }}>
                        <span style={{ color: '#666', fontSize: 13 }}>性别：</span>
                        <span>{portfolioData.child_info.gender === 'male' ? '男' : portfolioData.child_info.gender === 'female' ? '女' : '-'}</span>
                      </div>
                      <div style={{ marginBottom: 12 }}>
                        <span style={{ color: '#666', fontSize: 13 }}>生日：</span>
                        <span>{portfolioData.child_info.birthday || '-'}</span>
                      </div>
                    </>
                  )}
                </div>
                <div>
                  <h5 style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>最近活动</h5>
                  {portfolioData.recent_activities?.length > 0 ? (
                    portfolioData.recent_activities.slice(0, 3).map(a => (
                      <div key={a.id} style={{ padding: '8px 0', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between' }}>
                        <span>{getTypeName(a.type)} {a.title}</span>
                        <span style={{ color: '#999', fontSize: 12 }}>{a.date || a.activity_date || '-'}</span>
                      </div>
                    ))
                  ) : (
                    <div style={{ color: '#999', fontSize: 13 }}>暂无活动记录</div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* 活动记录 */}
          {tab === 'activities' && (
            <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
              <h4 style={{ fontSize: 14, marginBottom: 16 }}>📋 全部活动记录</h4>
              {portfolioData.recent_activities?.length > 0 ? (
                portfolioData.recent_activities.map(a => (
                  <div key={a.id} style={{ padding: 16, borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ fontWeight: 500 }}>{a.title || a.activity_title || '-'}</div>
                      <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                        {getTypeName(a.type)} | {a.date || a.activity_date || '-'}
                      </div>
                    </div>
                    <div style={{ color: '#999', fontSize: 12 }}>{a.status || ''}</div>
                  </div>
                ))
              ) : (
                <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无活动记录</div>
              )}
            </div>
          )}

          {/* 能力评估 */}
          {tab === 'assessments' && (
            <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
              <h4 style={{ fontSize: 14, marginBottom: 16 }}>📊 能力评估报告</h4>
              {renderAssessments(portfolioData.assessments)}
            </div>
          )}
        </>
      )}

      {!selectedChild && !loading && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 60, textAlign: 'center', color: '#999' }}>
          请选择上方孩子查看成长档案数据
        </div>
      )}
    </div>
  )
}
